import React from 'react';
// components
import Rooms from '../components/Rooms';
import BookForm from '../components/BookForm';
import HeroSlider from '../components/HeroSlider';
import Packages from '../components/Packages';
import ContactForm from '../components/ContactForm';
import Map from '../components/Map';
import Gallery from '../components/Gallery';

const Home = () => {
  return (
    <>
      <section id="hotel">
        <HeroSlider />
      </section>
      <div className='container mx-auto relative'>
        <div className='bg-accent/20 mt-4 p-4 lg:shadow-xl lg:absolute lg:left-0 lg:right-0 lg:p-0 lg:z-30 lg:-top-12'>
          <BookForm />
        </div>
      </div>
      <section id="rooms">
        <Rooms />
      </section>
      <section id="packages">
        <Packages />
      </section>
      <section id="okolica">
        <Map />
      </section>
      <section id='galeria'>
        <Gallery/>
      </section>
      <section id="contact">
        <ContactForm />
      </section>
    </>
  );
};

export default Home;
